<template>
   <div class="create-night-market">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
      <q-card-section class="card-content">
        <div class="q-gutter-md row items-start">
          <div class="title-bid-date">Date & Time Night Market End</div>
          <q-date
            v-model="nightMarketEnd"
            mask="YYYY-MM-DD HH:mm"
            color="orange"
          />
          <q-time
            v-model="nightMarketEnd"
            mask="YYYY-MM-DD HH:mm"
            color="orange" 
          />
        </div>
        <q-btn class="auction-item-add-btn" label="Submit" @click="requestCreateNightMarket"/>
        <q-btn class="auction-item-add-btn-dis" label="Disable Current Night Market" @click="requestDisableCurrent"/>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'CreateNightMarket',
  data () {
    return {
      nightMarketEnd: null
    }
  },
  props: {
    module: {
      require: true,
      type: Object
    }
  },
  methods: {
    ...mapActions({
      createNightMarket: 'user/createNightMarket',
      disableCurrentNightMarket: 'user/disableCurrentNightMarket'
    }),
    async requestCreateNightMarket() {
      this.$q.loading.show()

      await this.recaptchaLoad('createnightmarket')

      await this.createNightMarket({ expiresAt: this.nightMarketEnd })
        .then(response => {
          this.$q.notify({
              position: 'top-right',
              message: response.data.message,
              type: 'positive'
            })

            this.recaptchaLoad('createnightmarket')
        })
        .catch(error => {
          this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
        })

        this.$q.loading.hide()
    },
    async requestDisableCurrent () {
      this.$q.loading.show()

      await this.recaptchaLoad('disablecurrentnightmarket')

      await this.disableCurrentNightMarket()
        .then(response => {
          this.$q.notify({
              position: 'top-right',
              message: response.data.message,
              type: 'positive'
            })

            this.recaptchaLoad('disablecurrentnightmarket')
        })
        .catch(error => {
          this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
        })

        this.$q.loading.hide()
    }
  }
}
</script>
<style lang="scss">
.create-night-market {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .title-bid-date {
      font-size: 16px;
      font-weight: 700;
      color: white;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .auction-item-add-btn {
      margin-top: 16px;
      background-color: #FFC108;
    }

    .auction-item-add-btn-dis {
      margin-top: 16px;
      margin-left: 16px;
      background-color: #ff6b08;
      color: black;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
}
</style>